"use strict";

module.exports = require("./DOMException").interface;

Object.setPrototypeOf(module.exports.prototype, Error.prototype);



//////////////////
// WEBPACK FOOTER
// ./node_modules/_domexception@1.0.1@domexception/lib/public-api.js
// module id = vDMy
// module chunks = 0